import { useLocation, useParams } from "react-router-dom";

import { useAppStore } from "../../../../store/store";
import usePaxSession from "../usePaxSession";

const useMutatedPagePath = (): [string, string, string] => {
  const location = useLocation();
  const pathname = location.pathname;
  const origin = window.location.origin;

  const { itemId, itemType } = useParams<{
    itemId: string;
    itemType: string;
  }>();

  const paxSession = usePaxSession();

  const item =
    itemId && paxSession
      ? useAppStore
          .getState()
          .getChecklistItemById(itemId, paxSession.paxSessionId)
      : undefined;

  // common

  if (pathname.includes("not-found")) {
    return ["/session/not-found", "not-found", `${origin}/session/not-found`];
  }

  if (pathname.includes("ineligible")) {
    return [
      "/session/ineligible",
      "ineligible",
      `${origin}/session/ineligible`,
    ];
  }

  if (pathname.includes("login")) {
    return ["/login", "login", `${origin}/login`];
  }

  // session level

  if (pathname.includes("consent")) {
    return ["/session/consent", "consent", `${origin}/session/consent`];
  }

  if (pathname.includes("select-passenger")) {
    return [
      "/session/select-passenger",
      "select-passenger",
      `${origin}/session/select-passenger`,
    ];
  }

  // pax level
  const pathItemType = item?.itemType.toLowerCase() || itemType;
  const pathItemSelector = item ? "item" : "itemType";

  if (pathname.includes("questions")) {
    return [
      "/session/pax/questions",
      "pax / questions",
      `${origin}/session/pax/questions`,
    ];
  }

  if (pathname.includes("address")) {
    return [
      "/session/pax/address",
      "pax / address",
      `${origin}/session/pax/address`,
    ];
  }

  if (pathname.includes("checklist")) {
    return [
      "/session/pax/checklist",
      "pax / checklist",
      `${origin}/session/pax/checklist`,
    ];
  }

  // item level

  if (pathname.includes("scan")) {
    return [
      `/session/pax/${pathItemSelector}/${pathItemType}/scan`,
      `pax / ${pathItemSelector} / ${pathItemType} / scan`,
      `${origin}/session/pax/${pathItemSelector}/${pathItemType}/scan`,
    ];
  }

  if (pathname.includes("upload")) {
    return [
      `/session/pax/${pathItemSelector}/${pathItemType}/upload`,
      `pax / ${pathItemSelector} / ${pathItemType} / upload`,
      `${origin}/session/pax/${pathItemSelector}/${pathItemType}/upload`,
    ];
  }

  if (pathname.includes("processing")) {
    return [
      `/session/pax/${pathItemSelector}/${pathItemType}/apply`,
      `pax / ${pathItemSelector} / ${pathItemType} / apply`,
      `${origin}/session/pax/${pathItemSelector}/${pathItemType}/apply`,
    ];
  }

  if (pathname.includes("item") || pathname.includes("itemType")) {
    return [
      `/session/pax/${pathItemSelector}/${pathItemType}`,
      `pax / ${pathItemSelector} / ${pathItemType}`,
      `${origin}/session/pax/${pathItemSelector}/${pathItemType}`,
    ];
  }

  if (pathname.length <= 1) {
    return ["error", "error", `${origin}${pathname}`];
  }

  return ["untracked_path", "untracked_path", "untracked_path"];
};

export default useMutatedPagePath;
